var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 36C28.165 36 36 28.165 36 18.5C36 8.83502 28.165 1 18.5 1C8.83502 1 1 8.83502 1 18.5C1 28.165 8.83502 36 18.5 36Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14C15.8322 14 17.2057 14.5268 18.2184 15.4645C19.2311 16.4021 19.8 17.6739 19.8 19C19.8 20.3261 19.2311 21.5979 18.2184 22.5355C17.2057 23.4732 15.8322 24 14.4 24C12.9678 24 11.5943 23.4732 10.5816 22.5355C9.56893 21.5979 9 20.3261 9 19C9 17.6739 9.56893 16.4021 10.5816 15.4645C11.5943 14.5268 12.9678 14 14.4 14ZM22.5 14.8333C23.85 14.8333 24.75 16.6992 24.75 19C24.75 21.3008 23.85 23.1667 22.5 23.1667C21.15 23.1667 20.25 21.3008 20.25 19C20.25 16.6992 21.15 14.8333 22.5 14.8333ZM26.1 15.25C26.442 15.25 26.7408 15.9392 26.892 17.1217L26.9343 17.4908L26.9514 17.6867L26.9784 18.0983L26.9874 18.3142L26.9982 18.765L27 19L26.9982 19.235L26.9874 19.6858L26.9784 19.9025L26.9514 20.3133L26.9334 20.5092L26.8929 20.8783C26.7408 22.0617 26.4429 22.75 26.1 22.75C25.758 22.75 25.4592 22.0608 25.308 20.8783L25.2657 20.5092C25.2595 20.4439 25.2538 20.3786 25.2486 20.3133L25.2216 19.9017C25.2181 19.8297 25.2151 19.7578 25.2126 19.6858L25.2018 19.235V18.765L25.2126 18.3142L25.2216 18.0975L25.2486 17.6867L25.2666 17.4908L25.3071 17.1217C25.4592 15.9383 25.7571 15.25 26.1 15.25Z",
    fill: "url(#paint0_linear_2451_52913)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2451_52913",
    x1: 9,
    y1: 19,
    x2: 27,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0387F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ED4B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity3);
export default __webpack_public_path__ + "static/media/community_3.2a0e96a2a1252be050fda340e8b51843.svg";
export { ForwardRef as ReactComponent };